import { listenToNativeApp, NativeToWebMessageHandlers, CookieConsentMessage } from '@red-ui/bridge'
import { CookiePreferences, setCookiePreferences } from './cookiePreferences'
import { updateDynamicYieldCookieConsent } from './dynamicYield/dynamicYieldCookieConsent'

export const cookieConsentHandler = (): NativeToWebMessageHandlers['cookie_consent'] => {
  return (message: CookieConsentMessage) => {
    const { preferences } = message.payload

    const validatedPreferences: CookiePreferences = {
      'necessary-cookies': true,
      'marketing-advertising-cookies': preferences['marketing-advertising-cookies'] ?? false,
      'functional-cookies': preferences['functional-cookies'] ?? false,
      'analytics-cookies': preferences['analytics-cookies'] ?? false,
    }

    setCookiePreferences(validatedPreferences)
    updateDynamicYieldCookieConsent()
  }
}

export { listenToNativeApp }
